import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Authority } from '../models/authority';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnteUO } from '../models/EnteUO';
import { GeneralApiResponse } from '../models/Response/GeneralApiResponse';

@Injectable({
  providedIn: 'root'
})
export class AuthorityService {
  
  private enteUOData: BehaviorSubject<EnteUO>;
  public enteUOData$: Observable<EnteUO | null>;

  enteUO: any;
   
  constructor(
              private httpClient: HttpClient              
              ) {      
                this.enteUOData = new BehaviorSubject<EnteUO | null>(null);
                this.enteUOData$ = this.enteUOData.asObservable();
              } 
  
  getAll() {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/authority`);          
  }

  getSizeAll() {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/authority/size`);          
  }

  getAllOnlyActive() {    
    return this.httpClient.get<GeneralApiResponse>(`${environment.apiUrl}/superuser/authority/a/a/1`);          
  }

  insert(authority: Authority) {   
    return this.httpClient.post<any>(`${environment.apiUrl}/superuser/authority`, authority);
  }

  delete(id: string) {   
    return this.httpClient.delete<any>(`${environment.apiUrl}/superuser/authority/${id}`);
  }

  getById(id: string) {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/authority/${id}`);          
  }

  update(authority: Authority) {   
    return this.httpClient.put<any>(`${environment.apiUrl}/superuser/authority`, authority);
  }  

  getByEmailUser(email: string) {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/authority/email/${email}`);
  }

  //Chiamata che ottiene i dati dell'Ente dopo la selezione dell'albero, dati codeAOO e codeUO
  getEnteUO(codeAOO: string, codeUO: string) {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/authority/codeaoo/${codeAOO}/codeuo/${codeUO}`);
    //console.log(this.enteUO);
  }  
  
  // INIZIO GESTIONE BehaviorSubject   
  setEnteUOData(codeAOO: string, codeUO: string) {
    if(codeAOO==null || codeUO==null) {
      this.enteUOData.next(null);
    }
    else {
      this.getEnteUO(codeAOO, codeUO).subscribe({
        next: (response) => {      
          //console.log(response.result[0]); 
          var uo:EnteUO = response.result[0]
          this.enteUOData.next(uo);   // memorizzo i dati dell'Ente e UO selezionata
          localStorage.setItem('currentUO', JSON.stringify(uo));
        },
          error: (error) => {
          console.log(error.error);
          this.enteUOData.next(null);
        }
      });  
    }
  }

  public setEnteUO(value: EnteUO){
      this.enteUOData.next(value);
  }


  public get getEnteUOValue() {
    return this.enteUOData.value;
}
  
}
